module.exports = __webpack_public_path__ + "static/media/landmark-alt.c3677e55.svg";